/* Facade clic-pour-charger des videos YouTube des descriptions (voir snippets/pp-yt-safe.liquid).
   Aucune requete vers YouTube avant le clic ; la video se charge ensuite en youtube-nocookie. */
(function () {
  if (window.__ppYtFacade) return;
  window.__ppYtFacade = true;

  var css =
    '.pp-yt{position:relative;display:inline-block;vertical-align:middle;max-width:100%;height:auto;padding:0;border:0;cursor:pointer;background:#000 center/cover no-repeat;overflow:hidden}' +
    '.pp-yt__play{position:absolute;left:50%;top:50%;width:68px;height:48px;margin:-24px 0 0 -34px;background:#006d80;border-radius:12px}' +
    '.pp-yt__play::after{content:"";position:absolute;left:27px;top:14px;border-style:solid;border-width:10px 0 10px 17px;border-color:transparent transparent transparent #fff}' +
    '.pp-yt:hover .pp-yt__play{background:#00535f}' +
    '.pp-yt__note{position:absolute;left:0;right:0;bottom:0;padding:6px 10px;background:rgba(0,0,0,.7);color:#fff;font-size:13px;line-height:1.4;text-align:left}' +
    '.pp-yt:focus-visible{outline:3px solid #006d80;outline-offset:2px}';

  function init() {
    var frames = document.querySelectorAll('iframe[data-pp-yt]');
    if (!frames.length) return;
    if (!document.getElementById('pp-yt-css')) {
      var st = document.createElement('style');
      st.id = 'pp-yt-css';
      st.textContent = css;
      document.head.appendChild(st);
    }
    Array.prototype.forEach.call(frames, function (f) {
      var src = f.getAttribute('data-pp-yt');
      var m = src.match(/\/embed\/([^?&\/]+)/);
      if (!m) return;
      var w = parseInt(f.getAttribute('width'), 10) || 560;
      var h = parseInt(f.getAttribute('height'), 10) || 315;
      var t = f.getAttribute('title');
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'pp-yt';
      b.setAttribute('aria-label', 'Lire la vidéo' + (t && t !== 'YouTube video player' ? ' : ' + t : '') + ' (YouTube)');
      b.style.width = w + 'px';
      b.style.aspectRatio = w + ' / ' + h;
      b.style.backgroundImage = 'url(https://i.ytimg.com/vi/' + m[1] + '/hqdefault.jpg)';
      b.innerHTML = '<span class="pp-yt__play" aria-hidden="true"></span><span class="pp-yt__note">En lançant la vidéo, vous acceptez les cookies de YouTube.</span>';
      b.addEventListener('click', function () {
        var allow = f.getAttribute('allow') || '';
        if (allow.indexOf('autoplay') === -1) f.setAttribute('allow', (allow ? allow + '; ' : '') + 'autoplay; encrypted-media; picture-in-picture; fullscreen');
        f.setAttribute('allowfullscreen', '');
        f.removeAttribute('data-pp-yt');
        f.setAttribute('src', src + (src.indexOf('?') === -1 ? '?' : '&') + 'autoplay=1');
        b.parentNode.replaceChild(f, b);
      });
      f.parentNode.replaceChild(b, f);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
